import { p, section, ul } from "./blocks.js";

// Source: تحديث الشكاوى والاقتراحات سبتمبر2026م.docx (Arabic only). The English is a translation pending legal review.
export const feedback = {
  id: "feedback",
  path: "/feedback",
  title: { ar: "الشكاوى والاقتراحات", en: "Complaints & Suggestions" },
  sections: [
    section("complaints-and-suggestions", null, null, [
      p(
        "تحرص مؤسسة بشائر عبدالعزيز عمر باوهاب الإدارية بصفتها الجهة المشغلة لمنصة ( LUD) على توفير تجربة آمنة وموثوقة لجميع المستخدمين. وفي حال واجهت أي استفسار أو مشكلة أثناء استخدام المنصة أو الخدمات، أو رغبت في تقديم شكوى أو اقتراح عن مخالفة أو إساءة، يمكنك التواصل معنا من خلال قنوات الاتصال المخصصة.",
        "Bshair Abdulaziz Omar Bawhab Administrative Services, as the operator of the (LUD) platform, is keen to provide a safe and reliable experience for all users. If you have any inquiry or encounter any problem while using the platform or the services, or if you wish to submit a complaint or suggestion about a violation or abuse, you can contact us through the dedicated communication channels.",
      ),
      ul([
        ["الاستفسارات التقنية والتشغيلية: المراسلة عبر محادثة الدعم الفني", "Technical and operational inquiries: by message through the technical support chat."],
        ["الشكاوى أو الاقتراحات:", "Complaints or suggestions:"],
        [
          "يجب أن تكون الشكوى أو الاقتراح واضحًا ومحددًا، ويتضمن التفاصيل الكافية التي تساعدنا على التحقق ومعالجة المشكلة عبر البريد الإلكتروني [support@lud-sa.app](mailto:support@lud-sa.app)",
          "The complaint or suggestion must be clear and specific and include sufficient details to help us verify and address the problem, by email at [support@lud-sa.app](mailto:support@lud-sa.app)",
        ],
        [
          "نلتزم بمراجعة الاستفسارات والشكاوى والاقتراحات خلال فترة زمنية معقولة، ونتخذ الإجراءات المناسبة وفقًا لسياساتنا الداخلية والقوانين المعمول بها.",
          "We undertake to review inquiries, complaints, and suggestions within a reasonable period of time, and we take appropriate action in accordance with our internal policies and applicable laws.",
        ],
        [
          "يجوز عدم النظر في الشكاوى التي يتبين أنها كيدية أو مسيئة أو مكررة دون مبرر أو تفتقر إلى المعلومات اللازمة لدراستها، مع مراعاة المتطلبات النظامية ذات الصلة.",
          "Complaints found to be malicious, abusive, repeated without justification, or lacking the information necessary to study them may not be considered, subject to the relevant regulatory requirements.",
        ],
        [
          "لا يترتب على تقديم الشكوى بذاته استحقاق تلقائي للتعويض، ويتم النظر في أي تعويض أو معالجة وفقًا لنتيجة دراسة الشكوى والشروط والسياسات المعمول بها والأنظمة ذات الصلة.",
          "Submitting a complaint does not in itself give rise to an automatic entitlement to compensation. Any compensation or remedy is considered according to the outcome of studying the complaint, the applicable terms and policies, and the relevant regulations.",
        ],
        [
          "قد نتواصل مع مقدم الشكوى لطلب معلومات أو مستندات إضافية لازمة للتحقق منها ومعالجتها.",
          "We may contact the complainant to request additional information or documents needed to verify and address the complaint.",
        ],
        [
          "تتم معالجة بيانات الشكوى والمستندات المرتبطة بها وفق [سياسة الخصوصية](/privacy).",
          "Complaint data and related documents are processed in accordance with the [Privacy Policy](/privacy).",
        ],
      ]),
    ]),
  ],
};
